/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CCTokenInitializeTerminalRequest = {
    properties: {
        districtId: {
            type: 'string',
            isRequired: true,
            format: 'uuid',
        },
        baseAmount: {
            type: 'number',
            isRequired: true,
            format: 'double',
        },
    },
};